import React from 'react';
import { View, Text, ActivityIndicator, StyleSheet } from 'react-native';
import colors from '../../lib/colors';
import { msg } from '@lingui/core/macro';
import {
    type LocalizedMessage,
    useResolvedMessage,
} from '../../lib/i18n/messages';

export interface AppRouteBootScreenProps {
    message?: LocalizedMessage;
}

export default function AppRouteBootScreen({
    message = msg({
        id: 'auth.routeBoot.loadingWorkspace',
        message: 'Loading your workspace...',
        comment: 'Default loading text while a private app route initializes.',
    }),
}: AppRouteBootScreenProps) {
    const resolvedMessage = useResolvedMessage(message);
    return (
        <View style={styles.container}>
            <ActivityIndicator size="large" color={colors.primaryGreen} />
            <Text style={styles.message}>{resolvedMessage}</Text>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: colors.bgWeak,
        paddingHorizontal: 20,
    },
    message: {
        marginTop: 16,
        fontSize: 15,
        color: colors.text700,
        textAlign: 'center',
    },
});
